import { render, staticRenderFns } from "./InputPassword.vue?vue&type=template&id=5c8b35d0&"
import script from "./InputPassword.vue?vue&type=script&lang=ts&"
export * from "./InputPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports